import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=6a1716cf"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1716cf')) {
      api.createRecord('6a1716cf', component.options)
    } else {
      api.reload('6a1716cf', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=6a1716cf", function () {
      api.rerender('6a1716cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/components/editor.vue"
export default component.exports